<template>
  <view-container title="Login">
    <template v-slot:heading>
      <span>Login</span>
    </template>

    <template v-slot:default>
      <form
        action="/"
        class=" m-auto max-w-xs pb-4 text-base text-center u-spaceitems-tight "
        data-test="loginForm"
        @submit.prevent="login"
      >
        <input
          type="email"
          placeholder="Email"
          v-model="email"
          class=" bg-bg block font-light opacity-80 p-3 rounded-sm tint:focus-within:hover w-full "
        />
        <input
          type="password"
          placeholder="Password"
          v-model="password"
          class=" bg-bg block font-light opacity-80 p-3 rounded-sm tint:focus-within:hover w-full "
        />
        <button type="submit" class="o-obvious-button py-3 px-6">
          Connect
        </button>
      </form>
    </template>

    <template v-slot:after>
      <span>
        Or if ye no hae an accoont
        <router-link to="/signup" class="py-4 inline-block">
          ye&#160;kin&#160;create&#160;yin </router-link
        >.
      </span>
    </template>
  </view-container>
</template>

<script>
import firebase from '@/utilities/firebase-config'
import ViewContainer from '@/components/ViewContainer'

export default {
  name: `login`,
  components: {
    ViewContainer,
  },
  data() {
    return {
      email: ``,
      password: ``,
    }
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => this.$router.replace(`battles`),
          err => {
            alert(`Oopsi-daisy. ${err.message}`)
          }
        )
    },
  },
}
</script>
